import type { CheckoutLinkResource } from '@/features/billing/api/resources/checkout-link'
import type { CheckoutLink } from './CheckoutLink'

/**
 * Maps a job's Stripe checkout link.
 */
export function mapCheckoutLinkResourceToCheckoutLink(
  resource: CheckoutLinkResource,
): CheckoutLink {
  return {
    id: resource.id,
    url: resource.url,
  }
}
